export enum RenderPass {
    /**
     * Occurs after the background render pass.
     */
    Opaque,
}
